<template>
  <Drawer title="新建基础配置" :value="value" @input="value => $emit('input', value)" width="520" :mask-closable="false"
    :styles="styles">
    <div class="drawer-content">
      <span>基础配置</span>
      <div>
        规则名称:
        <el-input v-model="formData.ruleName" style="width: 200px;" size="small"></el-input>
      </div>
      <el-divider></el-divider>
      <div>
        规则优先级:
        <el-input v-model="formData.priorityLevel" style="width: 200px;" size="small"></el-input>
      </div>
      <el-divider></el-divider>
      <div>
        是否触发策略内容:
        <el-switch v-model="formData.strategySwitch" size="small" :active-value="1" :inactive-value="0"
          active-text="开" inactive-text="关"></el-switch>
      </div>
      <div class="dash-box">
        <div>匹配行为配置</div>
        <div class="form-item">
          匹配天数 <el-radio-group v-model="formData.matchDaysSwitch">
            <el-radio :label="0">关</el-radio>
            <el-radio :label="1">开</el-radio>
          </el-radio-group>
        </div>
        <div class="form-item">
          <el-input v-model="formData.matchDaysSectionS" style="width: 100px;" size="small"></el-input>
          天 ~
          <el-input v-model="formData.matchDaysSectionE" style="width: 100px;" size="small"></el-input>
          天
        </div>
        <div class="form-item">
          匹配次数 <el-radio-group v-model="formData.matchTimesSwitch">
            <el-radio :label="0">关</el-radio>
            <el-radio :label="1">开</el-radio>
          </el-radio-group>
        </div>
        <div class="form-item">
          <el-input v-model="formData.matchTimesSectionS" style="width: 100px;" size="small"></el-input>
          次 ~
          <el-input v-model="formData.matchTimesSectionE" style="width: 100px;" size="small"></el-input>
          次
        </div>
        <el-divider></el-divider>
        <div>发起方匹配配置</div>
        <div class="form-item">
          角色标签用户组
          <el-select v-model="formData.userSign" placeholder="请选择" size="small" v-el-select-loadmore="loadMore">
            <el-option v-for="item in signList" :key="item.name" :label="item.name" :value="item.name" >
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          匹配用户类型
          <el-select v-model="formData.matchUserType" placeholder="请选择" size="small">
            <el-option label="用户 male" :value="0"></el-option>
            <el-option label="主播 female" :value="1"></el-option>
            <el-option label="两者 both" :value="2"></el-option>
          </el-select>
        </div>
        <el-divider></el-divider>
        <div>被匹配角色配置</div>
        <div class="match-ticket-box" v-for="(outerItem, outerInd) in formData.matchRuleUserList" :key="outerInd">
          <i class="el-icon-error" @click="listRemove(outerInd)"></i>
          <div class="form-item">
            被匹配角色 {{ outerInd + 1 }} 类型
            <el-select v-model="formData.matchRuleUserList[outerInd].userSign" placeholder="请选择" size="small" v-el-select-loadmore="loadMore">
              <el-option v-for="item in signList" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
          <div class="form-item">
            被匹配角色 {{ outerInd + 1 }} 概率
            <el-input v-model="formData.matchRuleUserList[outerInd].matchUserChance" style="width: 200px;"
              size="small"></el-input>
            %
          </div>
          <div class="form-item">
            被匹配角色 {{ outerInd + 1 }} 优先级
            <el-input v-model="formData.matchRuleUserList[outerInd].matchPriorityLevel" style="width: 200px;"
              size="small"></el-input>
          </div>
          <div class="form-item">
            状态 <el-radio-group v-model="formData.matchRuleUserList[outerInd].valid">
              <el-radio :label="0">关</el-radio>
              <el-radio :label="1">开</el-radio>
            </el-radio-group>
          </div>
        </div>
        <el-button type="success" icon="el-icon-plus" circle @click="listAdd()"></el-button>
      </div>
    </div>
    <div class="drawer-footer">
      <Button style="margin-right: 8px" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="$emit('save', objToSubmit(formData))">保存</Button>
    </div>
  </Drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object
    },
    signList: {
      type: Array
    }
  },
  data() {
    return {
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      formData: {

      }
    }
  },
  watch: {
    config: {
      immediate: true,
      handler(val) {
        this.formData = this.submitToShow(val)
      }
    }
  },
  methods: {
    loadMore(){
      this.$emit("loadMore")
    },
    // isInner 是否内部增加
    listAdd() {
      this.formData.matchRuleUserList.push({
        matchRuleId: 0,
        userSign: '',
        matchUserChance: 0,
        matchPriorityLevel: 0,
        valid: 1
      })
    },
    // isInner 是否内部删除
    listRemove(ind) {
      if (this.formData.matchRuleUserList.length < 2) return
      this.formData.matchRuleUserList.splice(ind, 1)
    },
    submitToShow(obj) {
      let newObj = JSON.parse(JSON.stringify(obj))
      if (!newObj.matchDaysSection) {
        newObj.matchDaysSectionS = ''
        newObj.matchDaysSectionE = ''
      } else {
        const chars = newObj.matchDaysSection.split(',');
        newObj.matchDaysSectionS = chars[0]
        newObj.matchDaysSectionE = chars[1]
      }
      if (!newObj.matchTimesSection) {
        newObj.matchTimesSectionS = ''
        newObj.matchTimesSectionE = ''
      } else {
        const chars = newObj.matchTimesSection.split(',');
        newObj.matchTimesSectionS = chars[0]
        newObj.matchTimesSectionE = chars[1]
      }
      return newObj
    },
    objToSubmit(obj) {
      let newObj = JSON.parse(JSON.stringify(obj))
      newObj.matchDaysSection = newObj.matchDaysSectionS + ',' + newObj.matchDaysSectionE
      newObj.matchTimesSection = newObj.matchTimesSectionS + ',' + newObj.matchTimesSectionE
      newObj.matchRuleUserList = newObj.matchRuleUserList.map(item => {
        item.matchRuleId = newObj.id
        return item
      })
      return newObj
    },
  },
  directives: {
    'el-select-loadmore': (el, binding) => {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(
        '.el-select-dropdown .el-select-dropdown__wrap'
      )
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) binding.value()
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.drawer-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .dash-box {
    width: 100%;
    border: 2px dashed #eee;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    padding: 10px;

    .form-item {
      padding: 6px;

      .el-input {
        margin: 0 10px;
      }
    }
  }
}

.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}

.match-ticket-box {
  width: 100%;
  border-radius: 14px;
  background-color: #eee;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
  padding: 10px 0;

  >i {
    position: absolute;
    top: -5px;
    right: -4px;
    cursor: pointer;
    font-size: 24px;

    &:hover {
      color: #ef696c;
    }
  }

  .el-icon-remove {
    font-size: 20px;
    cursor: pointer;
    vertical-align: -2px;

    &:hover {
      color: #ef696c;
    }
  }
}
</style>